import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { HttpHeaders } from '@angular/common/http/src/headers';
import { environment } from '../../environments/environment';
import { CreateLogin } from '../models/create-login';
import { LoginReq } from '../models/user';
import { PaymentPost } from '../models/payment-post';

@Injectable()
export class ClassMasterService {

  private _classMasterUrl: string = `${environment.apiRootURL}/classmasters`;

  constructor(private _http: Http) { }

  getClassMaster(classMasterId: string) {
    console.log('HTTP GET class master ' + classMasterId);
    console.log(`${this._classMasterUrl}/${classMasterId}`);
    return this._http.get(`${this._classMasterUrl}/${classMasterId}`).map(response => response.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/services/class-master.service.ts